var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeekForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.707 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "Group 56687"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: 1,
    d: "M9.5.5a9 9 0 0 1 9 9h3l-4 4-4-4h3a7 7 0 1 0-2.94 5.7l1.42 1.44A9 9 0 1 1 9.5.5Z"
  }), /*#__PURE__*/React.createElement("text", {
    fontSize: 8,
    transform: "translate(4.5 12.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeekForward);
export default __webpack_public_path__ + "static/media/seek-forward.d30e3362e49e4da62b92b010d75efc56.svg";
export { ForwardRef as ReactComponent };